import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SafeModule, SimpleModalModule } from '@com-delta-idp/mnx-ui-kit';
import { PartnerContentModalComponent } from './partner-content-modal.component';

@NgModule({
  declarations: [PartnerContentModalComponent],
  imports: [CommonModule, ReactiveFormsModule, SimpleModalModule, SafeModule],
  exports: [PartnerContentModalComponent]
})
export class PartnerContentModalModule {}
